<template>
  <div class="dettaglio-trasferte-mobile mobile_customize col-xs-2" v-loading="loading">

    <div class="header-tab row row-custom" v-show="showPrincipal">
      <div class="col-4 no-padding icon-return">
        <el-button>
          <icon v-if="$route.name === 'home' ? false : true" name="riv-arrow2" scale="1.4" flip="horizontal"
            @click.native="link('RiepilogoTrasferte')"></icon>
        </el-button>
      </div>
      <div class="mobile-title-2line col-16 no-padding">
        {{ $t('trasferte.label.title').toUpperCase() }}
        <span class="subtitle">{{ getStato() }}</span>
      </div>
      <div class="col-4 no-padding">
        <div class="send" v-if="enableAction('sendResp')" @click="inoltraTrasferta('1')">
          <icon name="riv-sendMail" scale="2" class="pointer"></icon>
          <span>{{ $t('btn.sendResp') }}</span>
        </div>
        <div class="send" v-if="enableAction('sendSeg')" @click="inoltraPrenotazioni('1')">
          <icon name="riv-sendMail" scale="2" class="pointer"></icon>
          <span>{{ $t('btn.sendSecretary') }}</span>
        </div>
      </div>
    </div>

    <div class="testata-trasferta" v-show="showPrincipal">
      <div class="elemento row row-custom">
        <div class="label col-22 no-padding">{{ trasferta.tipoTrasferta === 'ORE' ? $t('trasferte.periodo') : $t('trasferte.periodo') }}</div>
        <div class="label col-2 no-padding">
          <icon v-if="testata" name="riv-downArr" scale="1" flip="vertical" @click.native="testata = !testata"></icon>
          <icon v-else name="riv-downArr" scale="1" @click.native="testata = !testata"></icon>
        </div>
        <div class="value col-24 no-padding" v-if="trasferta.tipoTrasferta === 'ORE'">
          {{ trasferta.dataDal | formattaData }} {{ '(' + trasferta.oraDal + ' - ' + trasferta.oraAl +')'}}
        </div>
        <div class="value col-24 no-padding" v-else>
          {{ trasferta.dataDal | formattaData }} - {{ trasferta.dataAl | formattaData }}
        </div>

      </div>
      <div v-show="testata">
        <div class="elemento row row-custom" v-if="trasferta.tipoTrasferta === 'ORE'">
          <div class="label col-24 no-padding">{{ $t('trasferte.numOre') }}</div>
          <div class="value col-24 no-padding">{{ trasferta.oreTrasferta }}</div>
        </div>
        <div class="elemento row row-custom">
          <div class="label col-24 no-padding">{{ $t('trasferte.label.partenza') }}</div>
          <div class="value col-24 no-padding">{{ trasferta.desProv }}</div>
        </div>
        <div class="elemento row row-custom">
          <div class="label col-24 no-padding">{{ $t('trasferte.label.destinazione') }}</div>
          <div class="value col-24 no-padding">{{ trasferta.desDest === undefined ? trasferta.desMan :
            trasferta.desDest}}</div>
        </div>
        <div class="elemento row row-custom">
          <div class="label col-24 no-padding">{{ $t('trasferte.label.soc') }}</div>
          <div class="value col-24 no-padding"> {{ trasferta.desCli }}</div>
        </div>
        <div class="elemento row row-custom">
          <div class="label col-24 no-padding">{{ $t('trasferte.label.uffRep') }}</div>
          <div class="value col-24 no-padding">{{ trasferta.desUff }}</div>
        </div>
        <div class="elemento row row-custom">
          <div class="label col-24 no-padding">{{ $t('trasferte.label.referente') }}</div>
          <div class="value col-24 no-padding">
            <el-tag :key="tag.mail" v-for="tag in trasferta.contatti" :disable-transitions="false">
              {{ tag.mail }}
            </el-tag>
            {{ trasferta.perRif }}
          </div>
        </div>
        <div class="elemento row row-custom">
          <div class="label col-24 no-padding">{{ $t('trasferte.label.motivo') }}</div>
          <div class="value col-24 no-padding" v-html="getMotivo(trasferta.notaDip)" style="white-space: pre-line">
          </div>
        </div>
      </div>
    </div>

    <diario-mobile v-if="tabActive === '1'" :trasferta="trasferta" :tbl_genSta="tbl_genSta" :tbl_socFat="tbl_socFat"
      @showModalComponent="showModalComponent" key="trasferta.idTrasferta"></diario-mobile>

    <biglietti-mobile v-if="tabActive === '2'" :trasferta="trasferta" @showModalComponent="showModalComponent"
      key="trasferta.idTrasferta"></biglietti-mobile>

    <trasporti-mobile v-if="tabActive === '3'" :trasferta="trasferta" @showModalComponent="showModalComponent"
      key="trasferta.idTrasferta"></trasporti-mobile>

    <auto-mobile v-if="tabActive === '4'" :trasferta="trasferta" :tbl_genSta="tbl_genSta"
      @showModalComponent="showModalComponent" key="trasferta.idTrasferta"></auto-mobile>

    <documenti-mobile v-if="tabActive === '5'" :trasferta="trasferta" key="trasferta.idTrasferta"></documenti-mobile>


    <div class="menu-trasferta" v-show="showPrincipal">
      <div class="action" @click="openTab('1')" :class="tabActive === '1' ? 'selected' : ''">
        <div class="box border-r">
          <div class="boxIcon">
            <icon name="riv-luggage" scale="2"></icon>
          </div>
          <span> {{ $t('trasferte.label.diario').toUpperCase() }}</span>
        </div>
      </div>
      <div class="action" @click="openTab('2')" :class="tabActive === '2' ? 'selected' : ''">
        <div class="box border-r">
          <div class="boxIcon">
            <icon name="riv-tickets" scale="2"></icon>
          </div>
          <span>{{ $t('trasferte.label.ticket').toUpperCase() }}</span>
        </div>
      </div>
      <div class="action" @click="openTab('3')" :class="tabActive === '3' ? 'selected' : ''">
        <div class="box border-r">
          <div class="boxIcon">
            <icon name="riv-taxi" scale="2"></icon>
          </div>
          <span> {{ $t('trasferte.label.trasporti').toUpperCase() }}</span>
        </div>
      </div>
      <div class="action" @click="openTab('4')" :class="tabActive === '4' ? 'selected' : ''">
        <div class="box border-r">
          <div class="boxIcon">
            <icon name="riv-autoPer2" scale="2"></icon>
          </div>
          <span>{{ $t('trasferte.label.auto').toUpperCase() }}</span>
        </div>
      </div>
      <div class="action" @click="openTab('5')" :class="tabActive === '5' ? 'selected' : ''">
        <div class="box">
          <div class="boxIcon">
            <icon name="riv-sp" scale="2"></icon>
          </div>
          <span>{{ $t('trasferte.label.doc').toUpperCase() }}</span>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import DiarioMobile from './DiarioMobile.vue'
import BigliettiMobile from './BigliettiMobile.vue'
import TrasportiMobile from './TrasportiMobile.vue'
import AutoMobile from './AutoAziendaliMobile.vue'
import DocumentiMobile from './DocumentiMobile.vue'
import moment from 'moment'

export default {
  components: {
    AutoMobile,
    TrasportiMobile,
    BigliettiMobile,
    DiarioMobile,
    DocumentiMobile
  },
  name: 'DettaglioTrasfertaMobile',
  i18n: {
    messages: {
      it_IT: {
        trasferte: {
          label: {
            title: "Trasferta",
            periodo: 'Data inizio /fine',
            dataIn: 'Data Inizio',
            dataFin: 'Data Fine',
            partenza: 'Partenza',
            destinazione: 'Destinazione',
            soc: 'Per conto della Società',
            uffRep: 'Ufficio/Reparto',
            referente: 'Persona di Riferimento',
            motivo: 'Motivazione',
            mensa: 'Mensa',
            alloggio: 'Alloggio',
            diario: 'Diario di Viaggio',
            ticket: 'Biglietto',
            trasporti: 'Trasporto',
            auto: 'Vettura Società',
            doc: 'Documenti'
          }
        }
      },
      fr_FR: {
        trasferte: {
          label: {
            title: 'Deplacement',
            periodo: 'Date du /au',
            dataIn: 'Date du',
            dataFin: 'Date au',
            partenza: 'Départ',
            destinazione: 'Destination',
            soc: 'Pour le compte',
            uffRep: 'Bureau/département',
            referente: 'Personne de référence',
            motivo: 'Motif',
            mensa: 'Repas',
            alloggio: 'Hébergement',
            diario: 'Détail du voyage',
            ticket: 'Billets Voyage',
            trasporti: 'Transports',
            auto: 'Voiture',
            doc: 'Documents',
          }
        }
      },
      es_ES: {
        trasferte: {
          label: {
            title: 'Viaje',
            periodo: 'Dia salid /regreso',
            dataIn: 'Dia salida',
            dataFin: 'Dia regreso',
            partenza: 'Salida',
            destinazione: 'Destino',
            soc: 'Por cuenta de la sociedad',
            uffRep: 'Oficina/Empresa',
            referente: 'Persona de referencia',
            motivo: 'Referencia',
            mensa: 'Comedor',
            alloggio: 'Alojamiento',
            diario: 'Agenda de viaje',
            ticket: 'Ticket',
            trasporti: 'Transporte',
            auto: 'Coche',
            doc: 'Documentos',
          }
        }
      },
      de_DE: {
        trasferte: {
          label: {
            title: 'Dienstreise',
            periodo: 'Datum von-bis',
            dataIn: 'Reisebeginn',
            dataFin: 'Reiseende',
            partenza: 'Abreiseort',
            destinazione: 'Reiseziel',
            soc: 'auf Kosten der Firma',
            uffRep: 'Büro/Abteilung',
            referente: 'Ansprechpartner',
            motivo: 'Grund',
            mensa: 'Kantine',
            alloggio: 'Unterkunft',
            diario: 'Reiseplan',
            ticket: 'Ticket',
            trasporti: 'Transport',
            auto: 'Firmenfahrzeug',
            doc: 'Dokumenten',
          }
        }
      },
      en_GB: {
        trasferte: {}
      }
    }
  },
  data() {
    return {
      loading: false,
      idTrasferta: '',
      tabActive: '0',
      tbl_genSta: [],
      tbl_genStaFat: [],
      tbl_socFat: [],
      trasferta: {},
      testata: false,
      showPrincipal: true
    }
  },
  filters: {
    /* Formatta la data: GGMMAAAA --> GG/MM/AAAA */
    formattaData: function (date) {
      if (date !== undefined && date !== '') {
        return moment(date, 'YYYYMMDD').format('DD/MM/YYYY')
        // return date.substr(6, 2) + '/' + date.substr(4, 2) + '/' + date.substr(0, 4)
      } else {
        return ' '
      }
    }
  },
  watch: {
    '$route'(to, from) {
      if (to.name === 'DettaglioTrasfertaMobile') {
        this.loading = true
        this.tabActive = '0'
        this.idTrasferta = this.$route.params.id
        this.loadGenSta()
        this.loadGenStaFat()
        this.loadSocfat()
        this.loadTrasferta(this.$route.params.id)
      }
    }
  },
  activated: function () {
    this.loading = true
    this.tabActive = '0'
    this.idTrasferta = this.$route.params.id
    this.loadGenSta()
    this.loadGenStaFat()
    this.loadSocfat()
    this.loadTrasferta(this.$route.params.id)
  },
  deactivated: function () {
    this.resetDati()
  },
  beforeMount: function () {
    /*this.loading = true
    this.idTrasferta = this.$route.params.id
    this.loadGenSta()
    this.loadGenStaFat()
    this.loadSocfat()
    this.loadTrasferta(this.$route.params.id)*/
  },
  mounted: function () {
  },
  methods: {
    link: function (route) {
      this.$set(this, 'tabActive', 0)
      this.$router.push({ name: route })
    },
    resetDati: function () {
      this.$set(this, 'tbl_genSta', [])
      this.$set(this, 'tbl_genStaFat', [])
      this.$set(this, 'tbl_socFat', [])
      this.$set(this, 'trasferta', {})
      this.$set(this, 'loading', false)
      this.$set(this, 'testata', false)
      this.$set(this, 'showPrincipal', true)
      this.$set(this, 'idTrasferta', '')
      this.$set(this, 'tabActive', '0')
    },
    loadTrasferta: function (idTrasferta) {
      this.loading = true
      this.$http.get('trasferte/' + this.$store.state.country + '/trasferte', {
        params: {
          idTrasferta: idTrasferta
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.trasferta = response.body.data[0]
            this.tabActive = '1'
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.loading = false
        })
    },
    inoltraTrasferta: function (statoAvanz) {
      this.loading = true
      let obj = {
        'idTrasferta': this.idTrasferta,
        'operazione': '*UPD',
        'statoAvanz': statoAvanz,
      }
      this.$http.post('trasferte/' + this.$store.state.country + '/trasferta', obj)
        .then(response => {
          if (response.body.rc === 0) {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'success',
              duration: process.env.duration
            })
            this.tabActive = '0'
            this.loadTrasferta(this.idTrasferta)
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
            this.loading = false
          }
        })
    },
    inoltraPrenotazioni: function () {
      this.loading = true
      let obj = {
        idTrasferta: this.idTrasferta,
        tipo: 'trasf',
        idPrenotazioni: [
          { id: '*ALL' }
        ],
        numId: '1',
      }
      this.$http.post('trasferte/' + this.$store.state.country + '/inoltraprenotazioni', obj)
        .then(response => {
          this.inoltraTrasferta('4')
          this.loading = false
        })
    },
    loadGenSta: function () {
      this.$http.get('datisoc/' + this.$store.state.country + '/gensta')
        .then(response => {
          if (response.body.rc === 0) {
            this.tbl_genSta = response.body.data
            this.tbl_genSta.unshift({ desLuogo: ' ', id: '', desc: ' ', luogo: ' ' })
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.loading = false
        })
    },
    loadGenStaFat: function () {
      this.$http.get('datisoc/' + this.$store.state.country + '/gensta', {
        params: {
          socFat: 'Y'
        }
      }).then(response => {
        if (response.body.rc === 0) {
          this.tbl_genStaFat = response.body.data
          this.tbl_genStaFat.unshift({ desLuogo: ' ', id: '', desc: ' ', luogo: ' ' })
        } else {
          this.$message({
            showClose: true,
            message: response.body.msg[0].msgTxt,
            type: 'error',
            duration: process.env.duration
          })
        }
        this.loading = false
      })
    },
    loadSocfat: function () {
      this.$http.get('datisoc/' + this.$store.state.country + '/socfat')
        .then(response => {
          if (response.body.rc === 0) {
            this.tbl_socFat = response.body.data
            this.tbl_socFat.unshift({ id: '', desc: ' ' })
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.loading = false
        })
    },
    getStato: function () {
      if (this.trasferta.terminata === 'T') {
        return '(' + this.$i18n.t('status.t') + ')'
      } else {
        return '(' + this.$i18n.t('status.' + this.trasferta.statoAvanz) + ')'
      }
    },
    enableAction: function (action) {
      let statoTrasferta = this.trasferta.statoAvanz
      if (this.trasferta.terminata === 'T') {
        return false
      }
      switch (action) {
        case 'sendResp':
          if (statoTrasferta === '' || statoTrasferta === '0') {
            return true
          } else {
            return false
          }
        case 'sendSeg':
          if (statoTrasferta === '3' || statoTrasferta === '4' || statoTrasferta === '6') {
            return true
          } else {
            return false
          }
      }
      return false
    },
    openTab: function (tab) {
      this.$set(this, 'tabActive', tab)
    },
    showModalComponent: function (value) {
      this.$set(this, 'showPrincipal', value)
    },
    getMotivo: function (nota) {
      return nota !== undefined ? nota.replace(/\\n|\\r\\n|\\n\\r|\\r/g, '<br>') : ''
    }
  }
}
</script>

<style lang="less">
@import "../../assets/less/general.less";
@import "../../assets/less/mobile_customize.less";
@import "../../assets/less/el-table_mobile.less";
@import "../../assets/less/el-form_mobile.less";

.dettaglio-trasferte-mobile {
  padding: 0;

  .header-tab {
    height: 40px;
    // border-bottom: 1px solid #007c74;
    text-align: center;
    margin-bottom: 20px;

    .icon-return {
      line-height: 65px;

      .el-button {
        height: 40px;
        width: 40px;
        // border-radius: 0px;
        //margin-top: 12px;
        //margin-left: 10px;
        padding: 0px;
        color: @greenRiva;
        float: left;
        border: none;
      }

      .el-button:hover {
        background-color: @white;
      }
    }

    .send {
      line-height: 40px;
      // position: fixed;
      // right: 20px;
      // bottom: 20px;
      float: right;
      color: #FF791A;
      margin-right: 10px;
      margin-left: 10px;

      span {
        display: block;
        line-height: 10px;
        .set-font(@family: "os-regular", @size: 10px, @color: #FF791A);
        text-transform: uppercase;
      }
    }
  }

  .testata-trasferta {
    background-color: #f2fbfb;
    border: 1px solid @greyLine;
    padding: 5px;

    .label {
      line-height: 20px;
      text-align: left;
      .set-font(@family: "os-bold", @size: 14px);
    }

    .value {
      line-height: 20px;
      text-align: left;
      .set-font(@family: "os-regular", @size: 14px, @color: #969696);
    }
  }

  .menu-trasferta {
    z-index: 100;
    background-color: #fff;
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 0;
    height: 60px;
    color: @grayMedium;
    display: block;
    text-align: left;
    border-top: 1px solid @greyLine;

    //padding-top: 4px;
    //padding-bottom: 4px;
    .action {
      height: 60px;
      width: 20%;
      float: left;
      text-align: center;

      .box {
        height: 54px;
        margin-top: 3px;
        margin-bottom: 3px;

        .boxIcon {
          height: 30px;
          margin-bottom: 5px;
        }

        span {
          .set-font(@size: 8px, @color: @grayMedium);
          letter-spacing: 1px;
          line-height: 14px;
          display: block;

          &::first-line {
            line-height: 1;
          }
        }

        &.border-r {
          border-right: 1px solid @greyLine;
        }
      }

      &.selected {
        background-color: #f2fbfb;
        color: @greenRiva !important;

        span {
          color: @greenRiva !important;
        }
      }
    }
  }

}


.status-saved {
  color: @grayMedium;
}

.status-send {
  color: @orangeMedium;
}

.status-approved {
  color: @greenApproved
}

.status-rejected,
.status-delete {
  color: #f44336
}

.inoltraBtn {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/TrasferteMobile/DettaglioTrasfertaMobile.vue